import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import AttendanceRuleConfig from '../components/AttendanceRuleConfig';
import { toast } from 'sonner';

const AdminAttendanceShiftConfigPage = ({
  dashboardHomePath = '/admin',
  importShiftPath = '/admin/import/work_shift',
  shiftCreatePath = '/admin/rules-shifts/create',
  scope = 'tenant',
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const successMessage = location.state?.shiftCreatedMessage;
    if (!successMessage) return;

    toast.success(successMessage);
    navigate(location.pathname, { replace: true, state: {} });
  }, [location.pathname, location.state, navigate]);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-foreground">Shift Configuration</h2>
          <p className="text-sm text-muted-foreground">
            {scope === 'global'
              ? 'The shifts every new workspace starts with. Editing these does not change a workspace already using them.'
              : 'Dedicated page for shifts and schedules.'}
          </p>
        </div>
        <Button variant="outline" onClick={() => navigate(dashboardHomePath)}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>
      </div>
      <AttendanceRuleConfig
        currentTab="shifts"
        hiddenTabs={['rules']}
        importShiftPath={importShiftPath}
        shiftCreatePath={shiftCreatePath}
        scope={scope}
      />
    </div>
  );
};

export default AdminAttendanceShiftConfigPage;
